import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const DetectarHuerfanos = ({ plataformaUrl }) => {
  const [totalDnis, setTotalDnis] = useState(0);
  const [procesados, setProcesados] = useState(0);
  const [limpiados, setLimpiados] = useState(0);
  const [loading, setLoading] = useState(false);

  const delay = (ms) => new Promise(res => setTimeout(res, ms));

  const ejecutarLimpieza = async () => {
    try {
      setLoading(true);
      setProcesados(0);
      setLimpiados(0);

      // 1️⃣ Traer DNIs
      const respDnis = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/moodles/obtenerTodosDnisActivos/"
      );

      const dnis = respDnis.data.dnis || [];
      setTotalDnis(dnis.length);

      if (!dnis.length) {
        Swal.fire("Info", "No hay DNIs activos", "info");
        return;
      }

//       console.log("🧾 Total DNIs:", dnis.length);

      const tamañoLote = 20;
      const procesadosSet = new Set();

      let totalLimpiados = 0;

      // 2️⃣ Procesar por lotes
      for (let i = 0; i < dnis.length; i += tamañoLote) {

        const lote = dnis.slice(i, i + tamañoLote)
          .filter(dni => !procesadosSet.has(dni));

        if (!lote.length) continue;

//         console.log(`📦 Lote ${i / tamañoLote + 1}:`, lote);

        for (const dni of lote) {

          try {
//             console.log(`🔍 Detectando DNI: ${dni}`);

            const detectResp = await axios.post(
              "https://wwwa.isepsantafe.net.ar/expedientes/moodles/detectarMatriculasHuerfanas",
              { dni, plataformaUrl }
            );

            const huerfanos = detectResp.data?.huerfanos || [];

//             console.log(`🧹 DNI ${dni} → huerfanos:`, huerfanos);

            // 👉 SI TIENE HUERFANOS → LIMPIAR
            if (huerfanos.length > 0) {
//               console.log(`🚀 Limpiando DNI: ${dni}`);

              await axios.post(
                "https://wwwa.isepsantafe.net.ar/expedientes/moodles/detectarMatriculasHuerfanas",
                {
                  dni,
                  plataformaUrl,
                  modo: "EXECUTE"
                }
              );

              totalLimpiados++;
              setLimpiados(totalLimpiados);

//               console.log(`✅ Limpieza OK DNI: ${dni}`);
            }

            procesadosSet.add(dni);
            setProcesados(procesadosSet.size);

            // 🔥 Delay anti rate-limit
            await delay(400);

          } catch (error) {
            console.error(
              `❌ Error DNI ${dni}:`,
              error.response?.data || error.message
            );

            // si es rate limit → esperar más
            if (error.response?.status === 429) {
//               console.log("⏳ Rate limit detectado, esperando 2s...");
              await delay(2000);
            }
          }
        }

        // pausa entre lotes
//         console.log("⏸ Pausa entre lotes...");
        await delay(1000);
      }

      Swal.fire(
        "Finalizado",
        `Procesados: ${procesadosSet.size} | Limpiados: ${totalLimpiados}`,
        "success"
      );

    } catch (error) {
      console.error("🔥 ERROR GENERAL:", error.response?.data || error.message);
      Swal.fire("Error", "Falló la limpieza", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>🧹 Limpieza de Matrículas Huérfanas</h2>

      <button onClick={ejecutarLimpieza} disabled={loading}>
        {loading ? "Procesando..." : "Iniciar"}
      </button>

      <div style={{ marginTop: "1rem" }}>
        <p>Procesados: {procesados} / {totalDnis}</p>
        <p>Limpiados: {limpiados}</p>
      </div>
    </div>
  );
};

export default DetectarHuerfanos;